import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12abd0c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fas fa-bolt me-2" }),
    /*#__PURE__*/_createTextVNode("ปัญหาสำคัญเร่งด่วน")
  ]),
  /*#__PURE__*/_createElementVNode("h6", { class: "card-subtitle text-muted" }, "จัดการข้อมูลปัญหาสำคัญเร่งด่วนต่าง ๆ ในพื้นที่")
], -1))
const _hoisted_3 = { class: "card-body my-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-asterisk me-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmergencyTableComponent = _resolveComponent("EmergencyTableComponent")!
  const _component_ProvinceFilterComponent = _resolveComponent("ProvinceFilterComponent")!
  const _component_EmergencyFormComponent = _resolveComponent("EmergencyFormComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ProvinceFilterComponent, { onChange: _ctx.filterChange }, {
          default: _withCtx(() => [
            _createElementVNode("button", {
              class: "btn btn-primary mb-3",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.createClick && _ctx.createClick(...args)))
            }, [
              _hoisted_4,
              _createTextVNode("เพิ่มปัญหาสำคัญเร่งด่วน ")
            ]),
            _createVNode(_component_EmergencyTableComponent, {
              "emergency-type-id": 2,
              "fiscal-year-id": _ctx.fiscalYearId,
              "province-id": _ctx.provinceId
            }, null, 8, ["fiscal-year-id", "province-id"])
          ]),
          _: 1
        }, 8, ["onChange"])
      ])
    ]),
    _createVNode(_component_EmergencyFormComponent, {
      ref: "emergencyForm",
      "emergency-type-id": 2,
      "province-id": _ctx.provinceId,
      "emergency-id": _ctx.selectedEmergencyId
    }, null, 8, ["province-id", "emergency-id"])
  ], 64))
}